import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=4cc9aab1"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports